import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserSettingsService } from 'api';

import { asyncPayloadCreator } from 'utils';

export const updateUserSettings = createAsyncThunk(
	'userSettings/updateUserSettings',
	async (credentials: any, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, UserSettingsService.update),
);
